import React from 'react'
import { trans } from 'sharedKernel/i18n'
import {
  OpportunityDetailMetaBar,
  OpportunityDetailMetaItem,
  OpportunityDetailMetaLabel,
  OpportunityDetailMetaValue,
} from '../../style'
import type { IStartupOpportunityDetail } from '../../../contracts'
import { formatOpportunityVerticalsDisplay } from 'domain/feature/hub/company/scouting/scoutingOpportunityDisplay'
import { displayOrDash } from '../../../behavior'

interface OpportunityDetailMetaProps {
  opportunity: IStartupOpportunityDetail
}

export const OpportunityDetailMeta = ({ opportunity }: OpportunityDetailMetaProps): JSX.Element => (
  <OpportunityDetailMetaBar>
    <OpportunityDetailMetaItem>
      <OpportunityDetailMetaLabel>{trans('scouting.about.offeringInstitution')}:</OpportunityDetailMetaLabel>
      <OpportunityDetailMetaValue>{displayOrDash(opportunity.requesterName)}</OpportunityDetailMetaValue>
    </OpportunityDetailMetaItem>
    <OpportunityDetailMetaItem>
      <OpportunityDetailMetaLabel>{trans('scouting.about.segment')}:</OpportunityDetailMetaLabel>
      <OpportunityDetailMetaValue>
        {displayOrDash(formatOpportunityVerticalsDisplay(opportunity) || null)}
      </OpportunityDetailMetaValue>
    </OpportunityDetailMetaItem>
    <OpportunityDetailMetaItem>
      <OpportunityDetailMetaLabel>{trans('scouting.about.impacted')}:</OpportunityDetailMetaLabel>
      <OpportunityDetailMetaValue>{displayOrDash(opportunity.impactedBy)}</OpportunityDetailMetaValue>
    </OpportunityDetailMetaItem>
  </OpportunityDetailMetaBar>
)
